// extracted by mini-css-extract-plugin
export default {"card":"kY-z","carouselContainer":"lY-z","carouselContent":"mY-z"};